// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.PredictedDataType.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * DataType component
 */
import React from 'react';
import { observer } from 'mobx-react';
import EventsUtils from 'EventUtils';
import FormGroup from 'share/components/controls/Izenda.FormGroup';
import Label from 'share/components/controls/Izenda.Label';
import DropDown from 'share/components/controls/Izenda.DropDown';
import Validator from 'share/components/hoc/Izenda.Validator';
import constants from 'logic/data/Izenda.CalculatedFieldConstants';
import { isEmpty } from 'lodash/fp';

const ValidatableDropDown = Validator()(DropDown);

@observer
class DataType extends React.Component {
  static displayName = 'DataType';

  /**
   * Handle on change of data type
   * @param {Object} e
   */
  onChangeDataType = (e: Object) => {
    let {
      store,
      store: { clonedModel: model },
      validation: valManager,
      reportDesigner,
      reportPart,
      type: { enableValidateDataType }
    } = this.props;

    model.changeDataType(e.value);

    valManager.reset();

    if (enableValidateDataType) {
      // validate data type vs function which is not none, expression and default
      if (
        model.functionName &&
        model.functionName !== constants.FUNCTION_NAME.NONE &&
        model.functionName !== constants.FUNCTION_NAME.EXPRESSION &&
        model.functionName !== constants.FUNCTION_NAME.DEFAULT &&
        !model.doesFunctionAcceptDataType()
      ) {
        valManager.updateErrors([
          {
            key: 'izendaDataType',
            messages: constants.MESSAGES.M04
          }
        ]);
        return null;
      }

      return store.validateExpressionWithReportKey(reportDesigner, reportPart).then(result => {
        if (!isEmpty(result)) {
          valManager.updateErrors(result);
        }
        return null;
      });
    }
  };

  render() {
    let notifyChange = EventsUtils.notifyChange;
    let {
      localization,
      store: { clonedModel: model }
    } = this.props;

    return (
      <FormGroup className="u_paddingRight">
        <Label className="col-md-3 text-left u_paddingLeft">{localization.getText('COMMON_LABEL_DATA_TYPE')}</Label>
        <div className="col-md-9 u_noPaddingAll">
          <ValidatableDropDown
            options={model.dataTypes}
            onChange={this.onChangeDataType}
            value={model.izendaDataType}
            field="izendaDataType"
          />
        </div>
      </FormGroup>
    );
  }
}

export default DataType;



// WEBPACK FOOTER //
// ./ui/share/components/controls/predictedField/Izenda.PredictedDataType.js